"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactActions = ContactActions;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _ContactActionsDesktop = require("./ContactActionsDesktop");
var _ContactActionMobile = require("./ContactActionMobile");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонент для кнопок действия в компонентах Контактов
 *
 * Адаптивный
 * Использует useDeviceType из ui-kit
 * В мобильной и планшетной версиях дизайн изменяется на серый-горизонтальные
 */
function ContactActions(props) {
  const deviceType = (0, _uiKit.useDeviceType)();
  if (deviceType !== 'desktop') {
    return /*#__PURE__*/React.createElement(_ContactActionMobile.ContactActionsMobile, props);
  }
  return /*#__PURE__*/React.createElement(_ContactActionsDesktop.ContactActionsDesktop, props);
}